import { createSlice } from '@reduxjs/toolkit';

const initialState = '2025-12-08';

/* istanbul ignore next */
const currentDateSlice = createSlice({
  initialState,
  name: 'currentDate',
  reducers: {},
});

export const { reducer: currentDateReducer } = currentDateSlice;
